module.exports = "https://cdn-static.kwai.net/kos/s101/nlav11312/shop/c_krn/krn-web/images/seller-banner.5aef1af491.png";